import { DownTime, DowntimePropertyName } from '../../model/DownTime'
import { ValidationMessage } from '../../model/ValidationResults'

export const validateTimeOnTimeOff = (
  manualDowntime: DownTime,
  downtimes?: DownTime[]
): ValidationMessage[] => {
  let validationMessages: ValidationMessage[] = []

  if (!manualDowntime.timeOn) {
    return [
      {
        property: DowntimePropertyName.TimeOn,
        message: 'The time on must be set for new downtime events.'
      }
    ]
  }

  if (manualDowntime.timeOff && manualDowntime.timeOn >= manualDowntime.timeOff) {
    validationMessages.push({
      property: DowntimePropertyName.TimeOn,
      message: 'The time on for the downtime event must be before the time off.'
    })
  }

  if (manualDowntime.timeOff && manualDowntime.timeOff <= manualDowntime.timeOn) {
    validationMessages.push({
      property: DowntimePropertyName.TimeOff,
      message: 'The time off for the downtime event must be after the time on.'
    })
  }

  if (!downtimes || downtimes.length === 0) {
    return validationMessages
  }

  const events: DownTime[] = downtimes.filter(
    downtime =>
      downtime.scadaObjectKey === manualDowntime.scadaObjectKey && downtime.id !== manualDowntime.id
  )

  const newTimeOff = manualDowntime!.timeOff // already would return if undefined

  const isTimeOnOverlapping = events.some(
    e => manualDowntime.timeOn >= e.timeOn && (!!!e.timeOff || manualDowntime.timeOn < e.timeOff)
  )

  const isTimeOffOverlapping = events.some(
    e => newTimeOff && newTimeOff > e.timeOn && (!!!e.timeOff || manualDowntime.timeOn <= e.timeOn)
  )

  if (isTimeOnOverlapping) {
    validationMessages.push({
      property: DowntimePropertyName.TimeOn,
      message:
        'The time on of the new downtime event cannot overlap another downtime event on the same SCADA object.'
    })
  }

  if (isTimeOffOverlapping) {
    validationMessages.push({
      property: DowntimePropertyName.TimeOff,
      message:
        'The time off of the new downtime event cannot overlap another downtime event on the same SCADA object.'
    })
  }

  return validationMessages
}
